import {useContext} from 'react'
import {contextProps, SkillContext} from '../utils/SkillContext'

export function useSkill<T>() {
  const context = useContext<contextProps<T>>(SkillContext)
  if (context === undefined) throw Error('useSkill must be used within SkillProvider')
  return context
}
